import React, { useState } from "react";
import { Table, Input, Row, Col, Tag } from "antd";
import useProjectLog from "./../../components/hooks/useProjectLog";
import moment from "moment";

const ProjectActivityTable = () => {
  const { data, isLoading } = useProjectLog();
  const [searchText, setSearchText] = useState("");

  // Unique users for the filter
  const uniqueCreatedBy = [
    ...new Set(data?.map((record) => record.created_by.toLowerCase())),
  ];

  const formattedFilters = uniqueCreatedBy?.map((name) => ({
    text: name,
    value: name,
  }));

  // Handle search input change
  const handleSearch = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  // Filter the data based on the search text
  const filteredData = data?.filter((record) =>
    record.description.toLowerCase().includes(searchText)
  );

  const columns = [
    {
      title: "Timestamp",
      dataIndex: "created_at",
      key: "created_at",
      render: (item) => moment.utc(item).local().format("YYYY-MMM-DD | h:mm A"),
    },
    {
      title: "Log",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (item) => <Tag color="green">{item}</Tag>,
      key: "role_role",
    },
    {
      title: "Region",
      dataIndex: "region",
      render: (item) => <Tag color="blue">{item}</Tag>,
      key: "region_region",
    },
    {
      title: "User Name",
      className: "capitalize",
      dataIndex: "created_by",
      key: "created_by",
      filters: formattedFilters,
      onFilter: (value, record) =>
        record.created_by?.toLowerCase()?.includes(value),
    },
  ];

  return (
    <div className="p-4">
      {/* Search input for log description */}
      <Row>
        <Col span={12}>
          <Input
            placeholder="Search by log description"
            value={searchText}
            onChange={handleSearch}
            allowClear
          />
        </Col>
      </Row>

      <div className="py-1"></div>
      <Table
        className="user-table-theme"
        dataSource={filteredData}
        loading={isLoading}
        columns={columns}
        rowKey="projectId"
      />
    </div>
  );
};

export default ProjectActivityTable;
